document.addEventListener("DOMContentLoaded", function () {
  const rootNode = document.querySelector(".related__product-slider");
  if (!rootNode) return;

  const viewportNode = rootNode.querySelector(".embla-viewport");
  const prevButtonNode = rootNode.querySelector(".embla-prev");
  const nextButtonNode = rootNode.querySelector(".embla-next");
  const desktopPrevBtn = document.querySelector(".desktop-prev-btn");
  const desktopNextBtn = document.querySelector(".desktop-next-btn");

  if (typeof EmblaCarousel !== "undefined" && viewportNode) {
    const isMobile = window.innerWidth < 768;
    const embla = EmblaCarousel(viewportNode, {
      loop: true,
      align: isMobile ? "center" : "start",
      slidesToScroll: 1,
      containScroll: "trimSnaps",
    });

    if (prevButtonNode) {
      prevButtonNode.addEventListener("click", () => embla.scrollPrev());
    }
    if (nextButtonNode) {
      nextButtonNode.addEventListener("click", () => embla.scrollNext());
    }

    const updateButtons = () => {
      if (desktopPrevBtn) desktopPrevBtn.disabled = !embla.canScrollPrev();
      if (desktopNextBtn) desktopNextBtn.disabled = !embla.canScrollNext();
    };

    embla.on("select", updateButtons);
    updateButtons();
  }
});
